import {
  FETCHED_PRODUCTS,
  FETCHING_PRODUCT,
  SET_GEORESOURCES,
  SETTING_FT_ELIGIBLE,
  FT_ELIGIBLE_SET
} from '../actions/actionTypes';
import { IProductsState } from '../../types/store/reducer';
import { AppActions } from '../../types/store/action';

const initialState: IProductsState = {
  loading: false,
  data: [],
  currency: null,
  localeId: '',
  countryCode : '',
  uplayData: {
    loading: false,
    ready: false,
    ftEligible: false
  }
};

export default function products(
  state = initialState,
  action: AppActions
): IProductsState {
  switch (action.type) {
    case FETCHING_PRODUCT:
      return {
        ...state,
        loading: true
      };

    case FETCHED_PRODUCTS:
      return {
        ...state,
        loading: false,
        data: action.products
      };

    case SET_GEORESOURCES:
      return {
        ...state,
        currency: action.currency,
        localeId: action.localeId,
        countryCode: action.countryCode
      };

    case SETTING_FT_ELIGIBLE:
      return {
        ...state,
        uplayData: { ...state.uplayData, loading: true }
      };

    case FT_ELIGIBLE_SET:
      return {
        ...state,
        uplayData: {
          ...state.uplayData,
          loading: false,
          ready: true,
          ftEligible: action.isEligible
        }
      };

    default:
      return state;
  }
}
